<div class="container">
    <div class="config-tab-title-area">
        <smart-icon name="dashboard" class="light"></smart-icon>
        <span class="h3-regular config-tab-title">
            CHOOSE VISUALIZATION
        </span>
    </div>
    <div class="visualizations-area">
        <tam-data-visualizations [config]="dataVisualizationsConfig" [active]="config.config.type">
        </tam-data-visualizations>
    </div>
</div>